export const USER_IMPERSONATE = "USER_IMPERSONATE";

export const userImpersonate = (data) => (dispatch) => {
  dispatch({
    type: USER_IMPERSONATE,
    payload: data,
  });
};
